/**
 * CloneDialog — preguntar el nombre de la copia antes de duplicar un CI.
 *
 * Es el patrón estándar del CMDB para "Copiar": se pide el nombre y se explica
 * QUÉ se copia y QUÉ no (siempre se copia la configuración y se deja en blanco
 * la identidad de la unidad física). Vive en un componente propio para que
 * todas las listas y todas las fichas pregunten lo mismo de la misma forma.
 */

import React, { useEffect, useRef, useState } from 'react';
import Dialog from './Dialog';

export default function CloneDialog({
  title = 'Copiar',
  nameLabel = 'Nombre de la copia',
  placeholder = 'Nombre del nuevo registro…',
  hint,
  defaultName = '',
  confirmLabel = 'Copiar',
  busy = false,
  error,
  onConfirm,
  onClose,
}) {
  const [name, setName] = useState(defaultName);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);
  useEffect(() => { if (defaultName) setName(defaultName); }, [defaultName]);

  const confirm = () => {
    const value = name.trim();
    if (!value || busy) return;
    onConfirm?.(value);
  };

  return (
    <Dialog
      title={title}
      icon="📋"
      onClose={onClose}
      busy={busy}
      footer={(
        <>
          <button type="button" className="list-btn-secondary" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button
            type="button"
            className="list-btn-primary"
            onClick={confirm}
            disabled={busy || !name.trim()}
          >
            {busy ? 'Copiando…' : confirmLabel}
          </button>
        </>
      )}
    >
      <div style={{ marginBottom: '1rem' }}>
        <label
          htmlFor="clone-name"
          style={{
            display: 'block',
            marginBottom: 6,
            fontSize: '0.8rem',
            fontWeight: 600,
            color: 'var(--text-secondary)',
          }}
        >
          {nameLabel}
        </label>
        <input
          id="clone-name"
          ref={inputRef}
          type="text"
          className="list-input"
          style={{ width: '100%', minWidth: 0 }}
          value={name}
          placeholder={placeholder}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') confirm(); }}
        />
        {hint && (
          <p className="list-hint" style={{ margin: '0.6rem 0 0' }}>{hint}</p>
        )}
      </div>
      {error && <div className="alert alert-danger py-2 mb-0" role="alert">{error}</div>}
    </Dialog>
  );
}
